import { Col, Container, Row } from "react-bootstrap";
import { Outlet } from "react-router";
import MenuCategories from "./MenuCategories/MenuCategories";

export default function LandingLayout() {
    return (
        <Container className="text-center">
            <Row>
                <Col xs={12} xl={3} className="bg-light bg-gradient border-top border-5 px-0">
                    <MenuCategories />
                </Col>
                <Col xs={12} xl={9} className="position-relative mt-0 mt-xl-3">
                    <Outlet />
                </Col>
            </Row>
        </Container >
    )
}